module.exports = __webpack_public_path__ + "static/media/bg_login.f4407da9.png";